import Base from "./Base.js";
import { searchSkills, searchTKSkills } from "api/graphql/queries.js";

import {
  getFieldHistory,
  listRopesProblems,
  listCoderbyteAssessments,
} from "./graphql/queries.js";

export default class CommonAPI extends Base {
  getFieldHistory(payload) {
    return this.apiClient.request({ query: getFieldHistory, payload });
  }

  listCoderbyteAssessments() {
    return this.apiClient.request({ query: listCoderbyteAssessments });
  }

  listRopesProblems() {
    return this.apiClient.request({ query: listRopesProblems });
  }

  searchSkills(payload) {
    return this.apiClient.request({
      query: searchSkills,
      payload,
    });
  }

  searchTKSkills(payload) {
    return this.apiClient.request({
      query: searchTKSkills,
      payload,
    });
  }
}
